import { Controller, type UseFormReturn } from 'react-hook-form';
import type { CarFormData } from '../types/car';
import { FormField } from './FormField';
import { PhoneInput } from './PhoneInput';
import { REGIONS } from '@moshina-bozor/shared';

// Format phone for display: +998901234567 -> +998 90 123 45 67
function formatPhoneDisplay(phone: string | undefined): string {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 12) return phone;
  return `+${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
}

// Get region label from value
function getRegionLabel(value: string | undefined): string {
  if (!value) return '';
  const region = REGIONS.find(r => r.value === value);
  return region?.label || value;
}

interface Props {
  form: UseFormReturn<CarFormData>;
}

export function StepContactInfo({ form }: Props) {
  const {
    register,
    control,
    watch,
    formState: { errors },
  } = form;

  const values = watch();

  return (
    <div className="form-step">
      <h2>Aloqa ma'lumotlari</h2>

      <FormField label="Viloyat" required error={errors.region}>
        <select {...register('region')} className={errors.region ? 'error' : ''}>
          <option value="">Tanlang...</option>
          {REGIONS.map((region) => (
            <option key={region.value} value={region.value}>
              {region.label}
            </option>
          ))}
        </select>
      </FormField>

      <FormField label="Tuman">
        <input {...register('district')} type="text" placeholder="Tuman nomi" />
      </FormField>

      <FormField label="Telefon raqam" required error={errors.contactPhone}>
        <Controller
          name="contactPhone"
          control={control}
          render={({ field }) => (
            <PhoneInput
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              name={field.name}
              className={errors.contactPhone ? 'error' : ''}
            />
          )}
        />
      </FormField>

      <FormField label="Qo'shimcha ma'lumot">
        <textarea
          {...register('description')}
          rows={3}
          placeholder="Masalan: yangi shinalar, servis kitob bor..."
        />
      </FormField>

      <div className="summary-card">
        <h3>Xulosa</h3>
        <div className="summary-grid">
          <div className="summary-item">
            <span className="summary-label">Mashina</span>
            <span className="summary-value">
              {values.brand} {values.model} {values.year}
            </span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Narxi</span>
            <span className="summary-value">
              {values.price?.toLocaleString()} {values.currency}
            </span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Joylashuv</span>
            <span className="summary-value">{getRegionLabel(values.region)}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Telefon</span>
            <span className="summary-value">{formatPhoneDisplay(values.contactPhone)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
